<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <construction-detail-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></construction-detail-form>
  </j-modal>
</template>

<script>

  import ConstructionDetailForm from './ConstructionDetailForm'
  export default {
    name: 'ConstructionDetailModal',
    components: {
      ConstructionDetailForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record,bool,type) {
        this.visible=true
        if(type){
          this.title = this.$t('详情');
          this.disableSubmit = true;
          this.$nextTick(()=>{
            this.$refs.realForm.edit(record,bool);
          })
        }else{
          this.title = this.$t('财务确认');
          this.disableSubmit = false;
          this.$nextTick(()=>{
            this.$refs.realForm.edit(record,bool);
          })
        }
        
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>